module.exports = __webpack_public_path__ + "static/media/Retro 1978 Police Officer.5ad86927.jpg";